// extracted by extract-css-chunks-webpack-plugin
module.exports = {"errorBoundary":"css-1rrrUvCRyc"};